import { createContext, useContext, useState } from "react";
import checkTheme from "../helpers/checkThemePreferrence";
import checkLanguage from "../helpers/checkLanguage";
import { useLocation } from "react-router-dom";
const AppContext = createContext();

const isDarkTheme = checkTheme();

function ContextProvider({ children }) {
  const [activeLink, setActiveLink] = useState("Home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(isDarkTheme);
  const [language, setLanguage] = useState(checkLanguage());
  const [showBanner, setShowBanner] = useState(true);
  const [dropDownLinks, setDropDownLinks] = useState("");
  const location = useLocation();

  const isMigrationPage = location.pathname === "/migration-guide";
  const shouldDisplayBanner = showBanner && !isMigrationPage;

  return (
    <AppContext.Provider
      value={{
        activeLink,
        setActiveLink,
        isMenuOpen,
        setIsMenuOpen,
        isDarkMode,
        setIsDarkMode,
        language,
        setLanguage,
        dropDownLinks,
        setDropDownLinks,
        shouldDisplayBanner,
        setShowBanner,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
export default ContextProvider;
